<!-- CHAT -->
<div class="chat flex-column fxFlex" *ngIf="conversation as conv">
  <!-- CHAT TOOLBAR -->
  <mat-toolbar class="chat-toolbar">
    <div class="flex-row-space-between-center fxFlex">
      <div class="flex-row-start-center">
        <!-- RESPONSIVE CHATS BUTTON-->
        <button
          mat-icon-button
          class="responsive-chats-button mr-16 fx-hide-gt-md"
          fuseMatSidenavToggler="chat-left-sidenav"
          aria-label="chats button"
        >
          <mat-icon>chat</mat-icon>
        </button>
        <!-- / RESPONSIVE CHATS BUTTON-->

        <!-- CHAT CONTACT-->
        <div class="chat-contact flex-row-start-center">
          <div class="avatar-wrapper">
            <img
              *ngIf="headerAvatar(conv)"
              [src]="headerAvatar(conv)"
              class="avatar"
              [alt]="displayName(conv)"
              onerror="
                if (this.src !== '/assets/images/avatars/default-no-avatar.png')
                  this.src = '/assets/images/avatars/default-no-avatar.png';
              "
            />
            <div *ngIf="!headerAvatar(conv)" class="avatar chat-initials-avatar accent">
              {{ displayName(conv).charAt(0) | uppercase }}
            </div>
          </div>

          <div class="chat-contact-name flex-row-start-center">
            {{ displayName(conv) }}
            <span
              *ngIf="store.isDirectPeerOnline(conv)"
              class="chat-online-dot ml-8"
              [matTooltip]="'CHAT.ONLINE' | translate"
            ></span>
            <mat-icon *ngIf="conv.is_locked" class="s-16 ml-8 secondary-text">lock</mat-icon>
          </div>
        </div>
        <!-- / CHAT CONTACT-->
      </div>

      <div>
        <button
          mat-icon-button
          (click)="togglePinnedPanel()"
          [matTooltip]="'CHAT.PINNED_TITLE' | translate"
          aria-label="pinned messages"
        >
          <mat-icon [class.accent-fg]="pinnedPanelOpen()">push_pin</mat-icon>
        </button>

        <button mat-icon-button [matMenuTriggerFor]="conversationMenu" aria-label="more">
          <mat-icon>more_vert</mat-icon>
        </button>

        <mat-menu #conversationMenu="matMenu">
          <button mat-menu-item (click)="toggleMute()">
            {{ (conv.is_muted ? 'CHAT.UNMUTE' : 'CHAT.MUTE') | translate }}
          </button>
        </mat-menu>
      </div>
    </div>
  </mat-toolbar>
  <!-- / CHAT TOOLBAR -->

  <!-- CHAT CONTENT (zone de drop) -->
  <div
    id="chat-content"
    class="fxFlex"
    #chatContent
    (scroll)="onScroll()"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave()"
    (drop)="onDrop($event)"
  >
    <div *ngIf="dragActive()" class="chat-drop-overlay">
      <mat-icon>file_upload</mat-icon>
      {{ 'CHAT.DROP_HERE' | translate }}
    </div>
    <!-- CHAT MESSAGES -->
    <div class="chat-messages">
      <div *ngIf="store.loadingOlder()" class="chat-loading-older secondary-text">…</div>

      <ng-container *ngFor="let message of messages; let i = index; trackBy: trackByUuid">
        <!-- DATE SEPARATOR -->
        <div *ngIf="showDateSeparator(i)" class="chat-date-separator secondary-text">
          <span>{{ message.created_at | date: 'fullDate' }}</span>
        </div>

        <!-- SÉPARATEUR NOUVEAUX MESSAGES (position last_read à l'ouverture) -->
        <div *ngIf="store.firstUnreadUuid() === message.uuid" class="chat-new-messages-separator">
          <span>{{ 'CHAT.NEW_MESSAGES' | translate }}</span>
        </div>

        <!-- SYSTEM MESSAGE -->
        <div *ngIf="message.type === 'system'" class="chat-system-row secondary-text">
          {{ systemLabel(message) }}
        </div>

        <!-- MESSAGE -->
        <div
          *ngIf="message.type !== 'system'"
          class="message-row"
          [id]="'chat-msg-' + message.uuid"
          [ngClass]="{
            me: isMine(message),
            contact: !isMine(message),
            'first-of-group': isFirstMessageOfGroup(message, i),
            'last-of-group': isLastMessageOfGroup(message, i),
            'is-pending': message.pending,
            'is-error': message.error,
            'mentions-me': mentionsMe(message),
          }"
        >
          <img
            *ngIf="shouldShowContactAvatar(message, i)"
            [src]="message.sender?.avatar_thumb || '/assets/images/avatars/default-no-avatar.png'"
            class="avatar"
            [alt]="message.sender?.name"
            onerror="
              if (this.src !== '/assets/images/avatars/default-no-avatar.png')
                this.src = '/assets/images/avatars/default-no-avatar.png';
            "
          />

          <div
            *ngIf="!isMine(message) && isFirstMessageOfGroup(message, i)"
            class="chat-sender-name secondary-text"
          >
            {{ message.sender?.name }}
          </div>

          <div class="bubble">
            <!-- PARENT (reply) -->
            <button
              *ngIf="message.parent"
              class="chat-parent-preview"
              type="button"
              (click)="scrollToMessage(message.parent.uuid)"
            >
              <span class="chat-parent-sender">{{ message.parent.sender?.name }}</span>
              <span class="chat-parent-body">
                {{ message.parent.deleted ? ('CHAT.DELETED_MESSAGE' | translate) : message.parent.body }}
              </span>
            </button>

            <!-- BODY -->
            <div *ngIf="message.deleted" class="message chat-deleted-message secondary-text">
              {{ 'CHAT.DELETED_MESSAGE' | translate }}
            </div>
            <div
              *ngIf="!message.deleted"
              class="message"
              [innerHTML]="message.body | chatBody: mentionNames() : ('CHAT.MENTION_FALLBACK' | translate)"
            ></div>

            <!-- ATTACHMENTS (lightbox images / téléchargement fichiers, URLs rafraîchies si stales) -->
            <div *ngIf="!message.deleted && message.attachments.length > 0" class="chat-attachments">
              <ng-container *ngFor="let attachment of message.attachments">
                <a
                  *ngIf="attachment.thumb_url"
                  [href]="attachment.url"
                  (click)="openAttachment(message, attachment, $event)"
                  class="chat-attachment-image"
                >
                  <img
                    [src]="attachment.thumb_url"
                    [alt]="attachment.file_name"
                    [width]="attachment.width || undefined"
                    [height]="attachment.height || undefined"
                    (load)="onAttachmentImageLoad()"
                  />
                </a>
                <a
                  *ngIf="!attachment.thumb_url"
                  [href]="attachment.url"
                  (click)="openAttachment(message, attachment, $event)"
                  class="chat-attachment-file"
                >
                  <mat-icon class="s-16">attach_file</mat-icon>
                  {{ attachment.file_name }}
                  <span class="secondary-text">({{ fileSize(attachment.size) }})</span>
                </a>
              </ng-container>

              <!-- Barre de progression d'upload (message optimiste) -->
              <div *ngIf="message.pending && message.upload_progress != null" class="chat-upload-progress">
                <div class="chat-upload-progress-bar" [style.width.%]="message.upload_progress"></div>
              </div>
            </div>

            <!-- RÉACTIONS (pills agrégées, toggle) -->
            <div *ngIf="!message.deleted && message.reactions.length > 0" class="chat-reactions">
              <button
                *ngFor="let reaction of message.reactions"
                type="button"
                class="chat-reaction-pill"
                [class.reacted]="reaction.reacted"
                [matTooltip]="reactorsTooltip(reaction)"
                (click)="toggleReaction(message, reaction.emoji)"
              >
                {{ reaction.emoji }} {{ reaction.count }}
              </button>
            </div>

            <!-- LINK PREVIEWS -->
            <div *ngIf="!message.deleted && message.metadata?.link_previews?.length" class="chat-link-previews">
              <a
                *ngFor="let preview of message.metadata?.link_previews"
                [href]="preview.url"
                target="_blank"
                rel="noopener noreferrer"
                class="chat-link-preview"
              >
                <img *ngIf="preview.image" [src]="preview.image" [alt]="preview.title || preview.url" />
                <div class="chat-link-preview-text">
                  <div class="chat-link-preview-title">{{ preview.title || preview.url }}</div>
                  <div *ngIf="preview.description" class="chat-link-preview-description secondary-text">
                    {{ preview.description }}
                  </div>
                  <div *ngIf="preview.site_name" class="chat-link-preview-site secondary-text">
                    {{ preview.site_name }}
                  </div>
                </div>
              </a>
            </div>

            <div class="time secondary-text">
              <mat-icon *ngIf="message.is_pinned" class="s-12 mr-4">push_pin</mat-icon>
              {{ message.created_at | date: 'short' }}
              <span *ngIf="message.is_edited" class="chat-edited-indicator">
                {{ 'CHAT.EDITED' | translate }}
              </span>
            </div>

            <!-- ERREUR D'ENVOI -->
            <div *ngIf="message.error" class="chat-send-error warn-fg">
              {{ 'CHAT.SEND_FAILED' | translate }}
              <button mat-button color="warn" (click)="retry(message)">
                {{ 'CHAT.RETRY' | translate }}
              </button>
            </div>
          </div>

          <!-- BARRE D'ACTIONS (survol) : réactions rapides + picker + répondre + menu -->
          <div *ngIf="!message.deleted && !message.pending" class="chat-message-actions">
            <button
              *ngFor="let quick of quickReactions"
              type="button"
              class="chat-quick-reaction"
              (click)="toggleReaction(message, quick)"
            >
              {{ quick }}
            </button>

            <chat-emoji-picker
              direction="down"
              [matTooltip]="'CHAT.REACT' | translate"
              (emojiSelected)="toggleReaction(message, $event)"
            ></chat-emoji-picker>

            <button mat-icon-button (click)="startReply(message)" [matTooltip]="'CHAT.REPLY' | translate">
              <mat-icon class="s-16">reply</mat-icon>
            </button>

            <button mat-icon-button [matMenuTriggerFor]="messageMenu" aria-label="message actions">
              <mat-icon class="s-16">more_horiz</mat-icon>
            </button>
          </div>
          <mat-menu #messageMenu="matMenu">
            <button *ngIf="message.body" mat-menu-item (click)="copyText(message)">
              {{ 'CHAT.COPY' | translate }}
            </button>
            <button *ngIf="isMine(message) && message.type === 'text'" mat-menu-item (click)="startEdit(message)">
              {{ 'CHAT.EDIT' | translate }}
            </button>
            <button *ngIf="isMine(message) || canManage()" mat-menu-item (click)="deleteMessage(message)">
              {{ 'CHAT.DELETE' | translate }}
            </button>
            <button *ngIf="canManage()" mat-menu-item (click)="togglePin(message)">
              {{ (message.is_pinned ? 'CHAT.UNPIN' : 'CHAT.PIN') | translate }}
            </button>
          </mat-menu>
        </div>
        <!-- / MESSAGE -->
      </ng-container>
    </div>
    <!-- CHAT MESSAGES -->
  </div>
  <!-- / CHAT CONTENT -->

  <!-- CHAT FOOTER -->
  <div class="chat-footer flex-column fxFlexZeroAuto">
    <!-- TYPING INDICATOR -->
    <div *ngIf="typingUsers().size > 0" class="chat-typing-line secondary-text">
      <span class="chat-typing-dots"><span></span><span></span><span></span></span>
      {{ typingLine() }}
    </div>

    <!-- CONTEXTE (édition / réponse) -->
    <div *ngIf="editing() as editingMessage" class="chat-composer-context secondary-text">
      <mat-icon class="s-14 mr-4">edit</mat-icon>
      {{ 'CHAT.EDITING' | translate }}
      <button mat-icon-button (click)="cancelEdit()"><mat-icon class="s-14">close</mat-icon></button>
    </div>
    <div *ngIf="replyingTo() as replyTarget" class="chat-composer-context secondary-text">
      <mat-icon class="s-14 mr-4">reply</mat-icon>
      {{ replyTarget.sender?.name }} : {{ replyTarget.body }}
      <button mat-icon-button (click)="replyingTo.set(null)"><mat-icon class="s-14">close</mat-icon></button>
    </div>

    <!-- ERREUR D'UPLOAD (pré-validation client) -->
    <div *ngIf="uploadError() as err" class="chat-composer-context warn-fg">
      <mat-icon class="s-14 mr-4">error_outline</mat-icon>
      {{ err.key | translate: { name: err.name } }}
    </div>

    <!-- STAGING DES FICHIERS -->
    <div *ngIf="stagedItems().length > 0" class="chat-staging">
      <div *ngFor="let item of stagedItems(); let i = index" class="chat-staging-item">
        <img *ngIf="item.previewUrl" [src]="item.previewUrl" [alt]="item.file.name" class="chat-staging-thumb" />
        <span *ngIf="!item.previewUrl" class="chat-staging-chip">
          <mat-icon class="s-16">attach_file</mat-icon>
          {{ item.file.name }} ({{ fileSize(item.file.size) }})
        </span>
        <button mat-icon-button class="chat-staging-remove" (click)="removeStaged(i)" aria-label="remove file">
          <mat-icon class="s-14">close</mat-icon>
        </button>
      </div>
    </div>

    <!-- AUTOCOMPLETE MENTIONS @ -->
    <div *ngIf="mentionCandidates().length > 0" class="chat-mention-popover">
      <button
        *ngFor="let candidate of mentionCandidates(); let i = index"
        type="button"
        class="chat-mention-candidate"
        [class.active]="i === mentionIndex()"
        (mousedown)="$event.preventDefault(); selectMention(candidate)"
        (mouseenter)="mentionIndex.set(i)"
      >
        <mat-icon *ngIf="candidate.isAll" class="s-16">campaign</mat-icon>
        <span [class.chat-mention-all-entry]="candidate.isAll">{{ candidate.name }}</span>
        <span *ngIf="candidate.isAll" class="secondary-text ml-8">{{ 'CHAT.MENTION_ALL_HINT' | translate }}</span>
      </button>
    </div>

    <!-- REPLY FORM -->
    <div class="reply-form flex-row-center-center fxFlexZeroAuto">
      <form class="flex-row-start-center fxFlex" (submit)="$event.preventDefault(); send()">
        <input
          type="file"
          #fileInput
          multiple
          hidden
          (change)="onFilesPicked($event)"
        />
        <button
          mat-icon-button
          type="button"
          [disabled]="conv.is_locked || editing()"
          (click)="fileInput.click()"
          aria-label="attach files"
        >
          <mat-icon class="secondary-text">attach_file</mat-icon>
        </button>

        <chat-emoji-picker [disabled]="conv.is_locked" (emojiSelected)="insertEmoji($event)"></chat-emoji-picker>

        <mat-form-field class="message-text fxFlex" floatLabel="auto">
          <textarea
            matInput
            #replyInput
            [placeholder]="(conv.is_locked ? 'CHAT.LOCKED' : 'CHAT.TYPE_MESSAGE') | translate"
            [(ngModel)]="draft"
            name="message"
            [rows]="1"
            [disabled]="conv.is_locked"
            (keydown)="onComposerKeydown($event)"
            (input)="onComposerInput()"
            (paste)="onPaste($event)"
          ></textarea>
        </mat-form-field>

        <button
          class="send-message-button"
          mat-icon-button
          type="submit"
          [disabled]="conv.is_locked"
          aria-label="Send message"
        >
          <mat-icon class="secondary-text">send</mat-icon>
        </button>
      </form>
    </div>
    <!-- / REPLY FORM -->
  </div>
  <!-- / CHAT FOOTER-->

  <!-- PANNEAU DES ÉPINGLÉS -->
  <div *ngIf="pinnedPanelOpen()" class="chat-pinned-panel">
    <div class="chat-pinned-header">
      <span>{{ 'CHAT.PINNED_TITLE' | translate }}</span>
      <button mat-icon-button (click)="togglePinnedPanel()" aria-label="close pinned">
        <mat-icon class="s-16">close</mat-icon>
      </button>
    </div>
    <div class="chat-pinned-list">
      <button
        *ngFor="let pinned of store.pinnedMessages()"
        type="button"
        class="chat-pinned-item"
        (click)="goToPinned(pinned)"
      >
        <span class="chat-pinned-sender">{{ pinned.sender?.name }}</span>
        <span class="chat-pinned-body">{{ pinned.body }}</span>
        <span class="chat-pinned-date secondary-text">{{ pinned.created_at | date: 'short' }}</span>
      </button>
      <div *ngIf="store.pinnedMessages().length === 0" class="p-16 secondary-text">
        {{ 'CHAT.NO_PINNED' | translate }}
      </div>
    </div>
  </div>

  <!-- LIGHTBOX (original signé) -->
  <div *ngIf="lightboxUrl() as url" class="chat-lightbox" (click)="closeLightbox()">
    <img [src]="url" alt="" (click)="$event.stopPropagation()" />
    <button mat-icon-button class="chat-lightbox-close" (click)="closeLightbox()" aria-label="close">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
<!-- / CHAT -->
